import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function checkDelivery(country,pincode) {
    alert("D "+ country + "  "+ pincode);
  return axiosInstance.get(`${backendUrl}/api/delivery/estimate`, {
        params: {
          country: country,
            pincode:pincode
        },
      }); // or whatever your API is
}

export default { checkDelivery };